import { SelectWithLabel } from '@adotel/components'
import { MenuItem, Paper, Typography } from '@material-ui/core'
import React from 'react'

import { DatePickerSelectionType } from '../../../helpers/date'
import useStyles from './styles/DateTypeSelectorHeader.styles'

interface DateTypeSelectorHeaderProps {
  typeOfSelector?: DatePickerSelectionType
  onChangeTypeOfSelector: (typeOfSelector: DatePickerSelectionType) => void
  // dateObject?: DateObject
  // dateObjectList?: DateObject[]
  hideShadows?: boolean
}

const DateTypeSelectorHeader: React.FC<DateTypeSelectorHeaderProps> = ({
  typeOfSelector,
  onChangeTypeOfSelector,
  hideShadows
}) => {
  const classes = useStyles()

  return (
    <Paper
      className={[
        classes.root,
        hideShadows ? classes.paperWithoutShadow : ''
      ].join(' ')}>
      <div className={classes.selectorContainer}>
        <SelectWithLabel
          noHelperText
          fullWidth
          // label={getTranslate('Date Picker Type')}
          value={typeOfSelector}
          onChange={(e) =>
            onChangeTypeOfSelector(e.target.value as DatePickerSelectionType)
          }
          size="small">
          <MenuItem key="Time Interval" value="TimeInterval">
            Time Interval
          </MenuItem>
          <MenuItem key="Custom Days" value="CustomDays">
            Custom Days
          </MenuItem>
        </SelectWithLabel>
      </div>
      <div>
        <Typography variant="body1">30 days</Typography>
      </div>
    </Paper>
  )
}

export default DateTypeSelectorHeader
